export default "__VITE_ASSET__0b7b58d6__"